<app-background-image data-state="shipping"></app-background-image>
<app-topbar></app-topbar>
<app-sidebar [showNavigation]="true">
    <div style="height: 45px"></div>
    <ul class="nav flex-column navbar-nav">
        <li class="d-grid gap-2">
            <button
                class="btn btn-outline-primary btn-block"
                type="button"
                *ngIf="showEdit"
                (click)="edit()"
            >
                Edit
            </button>
        </li>
    </ul>
</app-sidebar>

<div class="main-content">
    <div class="table-container">
        <div>
            <div class="main-content-header">
                <h3>Kajmand / Terminal</h3>
            </div>
            <div class="container-fluid">
                <div class="row justify-content-start">
                    <div class="col-12 col-xxl-3">
                        <app-info-group
                            headline="Kajmand bestilling"
                            size="fit"
                        >
                            <app-info-group-body>
                                <table>
                                    <tr>
                                        <td class="col-label">Dato</td>
                                        <td class="col-value">
                                            {{
                                                project.informantOrderDate
                                                    | tbaDate
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="col-label">Sag</td>
                                        <td class="col-value multiline-value">
                                            {{ project.informantOrderCase }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="col-label">Job</td>
                                        <td class="col-value multiline-value">
                                            {{ project.informantOrderJob }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="col-label">Maskine</td>
                                        <td class="col-value multiline-value">
                                            {{ project.informantOrderMachine }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="col-label">Job nr.</td>
                                        <td class="col-value multiline-value">
                                            {{ project.informantOrderMachineJobNumber }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="col-label">Klar v. skib</td>
                                        <td class="col-value multiline-value">
                                            {{ project.informantOrderReadyDate | tbaDate }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="col-label">Notat</td>
                                        <td class="col-value multiline-value">
                                            {{ project.informantOrderNote }}
                                        </td>
                                    </tr>
                                </table>
                            </app-info-group-body>
                        </app-info-group>
                    </div>
                    <div class="col-12 col-xxl-3">
                        <app-info-group
                            headline="Terminal"
                            size="fit"
                        >
                            <app-info-group-body>
                                <table>
                                    <tr>
                                        <td class="col-label">
                                            Forbrug v. flere maskiner
                                        </td>
                                        <td class="col-value multiline-value">
                                            {{
                                                project.terminalStatementMultipleMachines
                                            }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="col-label">
                                            Job nr.
                                        </td>
                                        <td class="col-value multiline-value">
                                            {{
                                                project.terminalStatementJobNumber
                                            }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="col-label">Notat</td>
                                        <td class="col-value multiline-value">
                                            {{ project.terminalStatementNote }}
                                        </td>
                                    </tr>
                                </table>
                            </app-info-group-body>
                        </app-info-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-1" style="min-width: 660px">
                        <app-info-group
                            headline="Terminal opgørelse"
                            size="fit"
                        >
                            <app-info-group-body>
                                <table>
                                    <thead>
                                        <tr>
                                            <th class="date">Dato</th>
                                            <th>Sats</th>
                                            <th class="value">Timer/Antal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="
                                                let item of project.projectTerminalStatements;
                                                let i = index
                                            "
                                        >
                                            <td>{{item.date| date:'dd/MM/yyyy' }}</td>
                                            <td>{{item.terminalStatementName}}</td>
                                            <td>{{item.value}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </app-info-group-body>
                        </app-info-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
